import { Injectable } from '@angular/core'

import { PRE_MATCH_PLACEMENT_WINDOW_MINUTES } from '../constants/common.constant'
import { HelperService } from './helper.service'

@Injectable({
	providedIn: 'root',
})
export class WhiteLabelMarketConfigService {
	constructor(private readonly helperService: HelperService) {}

	get configs() {
		return this.helperService.getUserData()?.user_fields?.PERMISSIONS ?? ''
	}

	showFeature(permission: string) {
		return this.configs.includes(permission)
	}

	isWithinPreMatchPlacementWindow(marketStartTime: string): boolean {
		const eventTime = new Date(marketStartTime).getTime()
		const now = Date.now()

		const diffInMs = eventTime - now
		const diffInMinutes = diffInMs / (1000 * 60)

		return diffInMinutes <= PRE_MATCH_PLACEMENT_WINDOW_MINUTES
	}
}
